export default __webpack_public_path__ + "c34e74e68083b51bf38c6628cdd5aa50.svg";